const boundForms = new Map();

function initialiseFloorplanFilters() {
  document.querySelectorAll("[data-floorplan-report-filters]").forEach((form) => {
    if (form.dataset.floorplanBound) return;
    form.dataset.floorplanBound = "true";
    const site = form.querySelector("[data-floorplan-site]");
    const space = form.querySelector("[data-floorplan-space]");
    const options = Array.from(space.options).map((option) => option.cloneNode(true));
    const update = () => {
      const selected = space.value;
      space.replaceChildren(...options.filter((option) => !option.value || option.dataset.siteId === site.value).map((option) => option.cloneNode(true)));
      space.value = Array.from(space.options).some((option) => option.value === selected) ? selected : "";
      space.disabled = !site.value;
    };
    site.addEventListener("change", update);
    boundForms.set(form, () => {
      const selected = space.value;
      space.replaceChildren(...options.map((option) => option.cloneNode(true)));
      space.value = selected;
      space.disabled = false;
      site.removeEventListener("change", update);
      delete form.dataset.floorplanBound;
    });
    update();
  });
}

document.addEventListener("DOMContentLoaded", initialiseFloorplanFilters);
document.addEventListener("turbo:load", initialiseFloorplanFilters);
// Rebind from the complete server-rendered option list after Turbo restores a page.
document.addEventListener("turbo:before-cache", () => {
  boundForms.forEach((restore) => restore());
  boundForms.clear();
});
if (document.readyState !== "loading") initialiseFloorplanFilters();
